import { PATIENT_CURRENT_REPORT_OPTIONS } from "./patient-current-report.utils";
import { PATIENT_LAST_REPORT_OPTIONS } from "./patient-last-report.utils";

// Merge tags added by SN-17895, gated behind the `clinical-merge-tags` flag. With the flag
// off these entries are stripped from the picker so it matches the pre-SN-17895 tree — the
// expanded report query is not sent either, so the tags would resolve to empty strings.
// Deleting this file (and its two call sites) is the whole flag cleanup.
const CLINICAL_TAG_SUFFIXES = [
  "AIR_CONDUCTION_THRESHOLDS",
  "BONE_CONDUCTION_THRESHOLDS",
  "PTA",
  "SRT",
  "SRT_MASKING",
  "WRS_MASKING",
  "TYMPANOMETRY_ADMITTANCE",
  "TYMPANOMETRY_ECV",
  "TYMPANOMETRY_PRESSURE",
  "ACOUSTIC_REFLEX_THRESHOLDS",
  "ACOUSTIC_REFLEX_DECAY",
  "QUICKSIN_METHOD",
  "OAE_TYPE",
  "OAE_RESULTS"
] as const;

const NON_PER_EAR_CLINICAL_KEYS = [
  "ICD10_CODES",
  "CUSTOM_TESTS",
  "FULL_AUDIOGRAM"
] as const;

const collectClinicalValues = (options: Record<string, string>) => {
  const keys = [
    ...CLINICAL_TAG_SUFFIXES.flatMap((suffix) => [
      `LEFT_${suffix}`,
      `RIGHT_${suffix}`
    ]),
    ...NON_PER_EAR_CLINICAL_KEYS
  ];

  return new Set(keys.map((key) => options[key]).filter(Boolean));
};

export const CLINICAL_MERGE_TAG_VALUES = new Set([
  ...collectClinicalValues(PATIENT_CURRENT_REPORT_OPTIONS),
  ...collectClinicalValues(PATIENT_LAST_REPORT_OPTIONS)
]);

type MergeTagMenuEntry = {
  title: string;
  value?: string;
  menu?: MergeTagMenuEntry[];
};

// Drops clinical entries, then drops any submenu left empty by that filtering.
export const stripClinicalMergeTags = <T extends MergeTagMenuEntry>(
  group: T
): T => {
  if (!group.menu) return group;

  const menu = group.menu
    .filter((entry) => !entry.value || !CLINICAL_MERGE_TAG_VALUES.has(entry.value))
    .map((entry) => stripClinicalMergeTags(entry))
    .filter((entry) => entry.value || entry.menu?.length);

  return { ...group, menu };
};
